export default "/icon-nav-sessions.svg";